const Reflux = require('@muzzylane/reflux');
const isNumber = require('lodash/isNumber');

const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const RegistrationTokenActions = Reflux.createActions({
    "updateRegTokenProject": {children: ["completed","failed"]},
    "addToken": {children: ["completed","failed"]}
});

RegistrationTokenActions.updateRegTokenProject.listen(function(actionID, params) {
    let self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    let exampleProjectId = params.exampleProjectId;
    let exampleProjectName = params.exampleProjectName;

    if(params.exampleProjectId.length !== 0) { //update operation

        if(!isNumber(parseInt(params.exampleProjectId, 10))) {
                valid = false;
                errorMsg = ErrorConsts.MISSING_PARAMS;
                errorUIRefs.push("projectId");
        }
        else {
            exampleProjectId = parseInt(params.exampleProjectId, 10);
        }

        if(!params.exampleProjectName){
            valid = false;
            errorMsg = ErrorConsts.MISSING_PARAMS;
            errorUIRefs.push("projectName");
        }
    }
    else { //delete operation
        exampleProjectId = "";
        exampleProjectName = "";
    }


    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    let reqBody = {
        exampleProjectId: exampleProjectId,
        exampleProjectName: params.exampleProjectName
    }

    ServerRequest.makeRequest('/authoring/registration_tokens/' + params.id + '/update', 'POST', JSON.stringify(reqBody))
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});

RegistrationTokenActions.addToken.listen(function(actionID, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if(params.token.length === 0) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("token");
    }

    if(params.description.length === 0) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("description");
    }

    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/registration_tokens/add', 'POST', JSON.stringify(params))
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});



module.exports = RegistrationTokenActions;